export default __webpack_public_path__ + "static/media/icon-app-hosting-round.35039772.svg";